import { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { TICKET_ATTACHMENT_MAX_MB } from '../../../../shared/const'

import AttachmentPicker, { pruefeAnhaenge } from './AttachmentPicker'
import styles from './detail.module.scss'

/**
 * Die Ablagefläche für Anhänge.
 *
 * Vorher stand an dieser Stelle ein grauer Satz — mitsamt dem Hinweis auf
 * Strg+V, also genau der Abkürzung, die man hier braucht und die man auf einem
 * Bildschirm voller Text übersieht. Jetzt ist der Hinweis die Fläche selbst:
 * groß genug, um aufzufallen, mit einem Ziel zum Hineinziehen, den Tasten als
 * Tastenkappen und dem Knopf für alle, die lieber eine Datei auswählen.
 *
 * Beide Wege enden in `pruefeAnhaenge` — Größe und Typ werden geprüft, egal ob
 * gezogen, eingefügt oder ausgewählt.
 */
export default function AttachmentDropzone({ onFiles, disabled }) {
	const [ueber, setUeber] = useState(false)

	const nimm = files => {
		setUeber(false)
		if (files?.length) onFiles(...pruefeAnhaenge(files))
	}

	return (
		<div
			className={clsx(styles.dropzone, ueber && styles.dropzoneOver)}
			onDragOver={event => {
				// Ohne preventDefault öffnet der Browser die Datei in einem neuen
				// Reiter, statt sie hier abzulegen.
				event.preventDefault()
				setUeber(true)
			}}
			onDragLeave={() => setUeber(false)}
			onDrop={event => {
				event.preventDefault()
				nimm(event.dataTransfer?.files)
			}}
		>
			<span className={styles.dropIcon} aria-hidden="true">
				<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
					<path d="M12 16V4" />
					<path d="m7 9 5-5 5 5" />
					<path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
				</svg>
			</span>

			<p className={styles.dropTitle}>Datei hierher ziehen oder einfügen</p>

			<p className={styles.dropHint}>
				Bildschirmfoto ausschneiden und einfügen mit{' '}
				<span className={styles.key}>Strg</span> + <span className={styles.key}>V</span> unter
				Windows und Linux, <span className={styles.key}>Cmd&nbsp;⌘</span> +{' '}
				<span className={styles.key}>V</span> auf dem Mac. Ziehen aus dem Datei-Explorer
				(Windows) beziehungsweise dem Finder (Mac) geht ebenso.
			</p>

			<AttachmentPicker onFiles={onFiles} disabled={disabled} hint={false} />

			<p className={styles.dropTypes}>
				Bilder (PNG, JPEG, GIF, WebP), PDF und Videos (MP4, MOV) bis{' '}
				{TICKET_ATTACHMENT_MAX_MB} MB
			</p>
		</div>
	)
}

AttachmentDropzone.propTypes = {
	onFiles: PropTypes.func.isRequired,
	disabled: PropTypes.bool
}

AttachmentDropzone.defaultProps = {
	disabled: false
}
